export interface ReferenceField {
  name: string;
  type: string;
  description: string;
}

export const brCreateFields: ReferenceField[] = [
  { name: "pref", type: "string", description: "Envie sempre br_48_padrao. Omitir pref usa o padrão histórico de Clash Squad e pode criar uma sala CS cobrada." },
  { name: "team_mode", type: "solo | duo | squad", description: "Formato do time; squad quando omitido. A sala tem 48 vagas de jogador e o formato se fixa na criação." },
  { name: "room_name", type: "string", description: "Nome da sala; RX SALAS quando omitido." },
  { name: "password", type: "string", description: "Senha de acesso; quando omitida, é gerada uma senha aleatória de 2 dígitos. Leia a senha resolvida em request.room.password." },
  { name: "maps", type: "array · 1 a 5 itens", description: "Cria um circuito, mesmo com um único mapa. Para queda avulsa, omita o campo. Aceita bermuda, purgatorio, kalahari, nova_terra e solara; os mapas podem repetir." },
  { name: "start_delay_seconds", type: "number", description: "0 desliga o auto-start. Um valor positivo inicia a primeira queda após a entrada do primeiro jogador, com teto de 1800 segundos. Sem auto-start, chame /start." },
  { name: "match_interval_seconds", type: "number", description: "Intervalo entre quedas do circuito; padrão de 180 segundos. Não controla o início da primeira queda." },
  { name: "spectators", type: "boolean", description: "false por padrão: somente a vaga do host. true abre 30 vagas de espectador, uma delas ocupada pelo host." },
  { name: "rules", type: "object", description: "Regras BR com valores booleanos estritos. Envie apenas o que deseja mudar; as demais regras ficam no padrão." },
];

export const brRuleFields: ReferenceField[] = [
  { name: "rules.vehicles", type: "boolean · padrão false", description: "true habilita veículos no mapa." },
  { name: "rules.allow_emulators", type: "boolean · padrão false", description: "Omitido ou false bloqueia jogadores de emulador: checagem nativa ligada, EMULADOR = SIM. Somente true permite: checagem nativa desligada, EMULADOR = DESABILITADO. Sem alias na raiz; exclusivo do BR em POST /rooms, sem suporte em /rooms/custom de CS." },
  { name: "rules.airdrop", type: "boolean · padrão true", description: "Habilita caixas de airdrop." },
  { name: "rules.character_skills", type: "boolean · padrão true", description: "Habilita habilidades de personagem." },
  { name: "rules.loadout", type: "boolean · padrão true", description: "Habilita o carregamento do perfil." },
  { name: "rules.ammo_limit", type: "boolean · padrão true", description: "Limita munição; false habilita munição infinita." },
  { name: "rules.throwables_limit", type: "boolean · padrão true", description: "Limita arremessáveis; false habilita quantidade infinita." },
  { name: "rules.weapon_box", type: "boolean · padrão true", description: "Habilita o baú de batalha." },
  { name: "rules.item_generator", type: "boolean · padrão false", description: "Habilita a máquina de recursos." },
  { name: "rules.event_gameplay", type: "boolean · padrão false", description: "Habilita a jogabilidade do evento." },
  { name: "rules.revive", type: "boolean · padrão false", description: "Permite reviver companheiros." },
  { name: "rules.headshot_only", type: "boolean · padrão false", description: "true permite dano somente em acertos na cabeça." },
  { name: "rules.spectate_after_death", type: "boolean · padrão true", description: "Permite assistir após morrer; false desabilita essa opção." },
];

export const brDefaultRequestSample = `{
  "pref": "br_48_padrao",
  "team_mode": "squad",
  "room_name": "RX BR",
  "password": "11",
  "start_delay_seconds": 0,
  "rules": {
    "allow_emulators": false
  }
}`;

export const brEmulatorsRequestSample = `{
  "pref": "br_48_padrao",
  "team_mode": "duo",
  "room_name": "RX BR CIRCUITO",
  "password": "11",
  "maps": ["bermuda", "purgatorio", "kalahari"],
  "start_delay_seconds": 0,
  "match_interval_seconds": 180,
  "rules": {
    "allow_emulators": true
  }
}`;

export const brReadyResponseSample = `{
  "requestId": "req_exemplo_br",
  "status": "completed",
  "created": true,
  "request": {
    "room": {
      "session_id": "sess_exemplo_br",
      "room_id": "12345678",
      "password": "11"
    }
  }
}`;

export const statusRootFields: ReferenceField[] = [
  { name: "room", type: "object", description: "Identidade, estado e contadores da sala." },
  { name: "teams", type: "array", description: "Times presentes; cada item contém apenas slots ocupados." },
  { name: "spectators", type: "array", description: "Lista de espectadores, no mesmo formato de um slot." },
  { name: "emulator_players", type: "string[]", description: "UIDs de jogadores já observados em emulador. Não representa a política de entrada da sala." },
  { name: "emulator_count", type: "number", description: "Resumo equivalente a emulator_players.length. Zero jogadores detectados não confirma bloqueio de emuladores." },
  { name: "host_online", type: "boolean", description: "Indica se o bot que hospeda a sala está conectado." },
  { name: "verified_at", type: "ISO 8601", description: "Última confirmação obtida diretamente do jogo." },
  { name: "status_stale", type: "boolean", description: "true quando a resposta veio do último estado conhecido." },
  { name: "status_error", type: "string | null", description: "Motivo que impediu a atualização do estado." },
  { name: "profiles_partial", type: "boolean", description: "Parte dos perfis não retornou skills ou pet." },
  { name: "profiles_error", type: "boolean", description: "A consulta de perfis falhou por completo." },
];

export const roomFields: ReferenceField[] = [
  { name: "session_id", type: "string", description: "Identificador usado em todas as operações seguintes." },
  { name: "request_id", type: "string | null", description: "Request de criação que originou a sala." },
  { name: "id", type: "string", description: "ID numérico visível no Free Fire; substitui room_id nesta rota." },
  { name: "name", type: "string", description: "Nome atual da sala; substitui room_name nesta rota." },
  { name: "password", type: "string", description: "Senha atual de acesso." },
  { name: "invite_code", type: "string | null", description: "Código curto de convite." },
  { name: "invite_link", type: "string | null", description: "Link direto para entrar na sala." },
  { name: "mode", type: "string | null", description: "Preset aplicado, anteriormente chamado pref." },
  { name: "emulator_check_enabled", type: "boolean | null", description: "Checagem nativa observada do servidor: true = ligada; false = desligada; null = ainda não observada. Não é a permissão allow_emulators nem um eco do request. Campo ausente, inclusive quando o servidor omite false, não comprova checagem desligada; trate como desconhecido." },
  { name: "status", type: "string", description: "active, started ou completed." },
  { name: "players", type: "number", description: "Contagem de jogadores. Não é mais um array." },
  { name: "max_players", type: "number | null", description: "Capacidade da sala." },
  { name: "spectators", type: "number", description: "Contagem; a lista fica em spectators na raiz." },
];

export const slotFields: ReferenceField[] = [
  { name: "index", type: "number", description: "Posição dentro do time ou da lista de espectadores." },
  { name: "uid", type: "string", description: "UID usado também pelo endpoint de kick." },
  { name: "name", type: "string", description: "Nick atual do jogador." },
  { name: "emulator", type: "boolean", description: "true quando o jogador foi detectado em emulador." },
  { name: "skills", type: "number[]", description: "IDs das habilidades; vazio sem profiles=1." },
  { name: "pet", type: "number | null", description: "Habilidade do pet; null sem profiles=1." },
];

export const statusResponseSample = `{
  "room": {
    "session_id": "sess_1784602526837_aa70056d",
    "request_id": "b3f1...",
    "id": "39550190",
    "name": "SALA COMPETITIVA",
    "password": "123",
    "mode": "cs_8_sem_carregamento",
    "emulator_check_enabled": null,
    "status": "active",
    "players": 4,
    "max_players": 8,
    "spectators": 0
  },
  "teams": [{
    "index": 1,
    "slots": [{
      "index": 0,
      "uid": "123456789",
      "name": "ProPlayer1",
      "emulator": false,
      "skills": [1, 2],
      "pet": null
    }]
  }],
  "spectators": [],
  "emulator_players": [],
  "emulator_count": 0,
  "host_online": true,
  "verified_at": "2026-08-09T13:41:02.113Z",
  "status_stale": false,
  "status_error": null
}`;

export const brStatusResponseSample = `{
  "room": {
    "session_id": "sess_exemplo_br",
    "request_id": "req_exemplo_br",
    "id": "12345678",
    "name": "RX BR",
    "password": "11",
    "mode": "br_48_padrao",
    "status": "active",
    "players": 0,
    "max_players": 48,
    "spectators": 1,
    "emulator_check_enabled": true
  },
  "teams": [],
  "emulator_players": [],
  "emulator_count": 0,
  "host_online": true,
  "verified_at": "2026-10-13T12:00:00.000Z",
  "status_stale": false,
  "status_error": null
}`;

export const startResponseSample = `{
  "ok": true,
  "confirmed": true,
  "handed_off": true,
  "guest_left": true,
  "room": {
    "session_id": "sess_1784602526837_aa70056d",
    "room_id": "39550190",
    "status": "started",
    "player_count": 8
  },
  "tracking": {
    "tracked": null,
    "reason": "pending"
  }
}`;

export const resultResponseSample = `{
  "roomId": "63215038",
  "sessionId": "sess_1785766650164_d1cb7f25",
  "status": "finalizada",
  "poll_after_seconds": null,
  "started_at": "2026-08-03T14:17:34.873Z",
  "finished_at": "2026-08-03T14:32:10.001Z",
  "teams": [{
    "team": 0,
    "won": true,
    "players": [{
      "account_id": 10904386688,
      "nickname": "FELPSZ 2M",
      "platform": "mobile",
      "kills": 7,
      "deaths": 3,
      "damage": 1420,
      "headshots": 4,
      "mvp": true,
      "mvp_medal": "gold",
      "won": true,
      "played": true
    }]
  }]
}`;

export const webhookVerificationSample = `const crypto = require("crypto");

function assinaturaConfere(req, corpoCru, secret) {
  const ts = req.headers["x-rxsalas-timestamp"];
  const recebida = String(req.headers["x-rxsalas-signature"] || "")
    .replace("sha256=", "");

  const idade = Math.abs(Math.floor(Date.now() / 1000) - Number(ts));
  if (!Number.isFinite(idade) || idade > 300) return false;

  const esperada = crypto.createHmac("sha256", secret)
    .update(\`${"${ts}.${corpoCru}"}\`)
    .digest("hex");

  const a = Buffer.from(esperada);
  const b = Buffer.from(recebida);
  return a.length === b.length && crypto.timingSafeEqual(a, b);
}`;

export const billingModes = [
  { name: "prepaid", behavior: "Debita a carteira e bloqueia a criação quando o saldo é insuficiente.", gate: "Saldo obrigatório" },
  { name: "postpaid", behavior: "Cria e debita mesmo que a carteira fique negativa; o acerto ocorre depois.", gate: "Não bloqueia por saldo" },
  { name: "included", behavior: "A criação não debita carteira.", gate: "Uso incluído" },
  { name: "discount", behavior: "Debita o preço específico configurado para a conta parceira.", gate: "Preço negociado" },
  { name: "coparticipation", behavior: "Não funciona por chave de API porque não existe um membro pagador no request.", gate: "Recusado com 403" },
];

export const customFunctions = [
  { name: "loadout", description: "Ativa itens do carregamento do perfil.", status: "validado" },
  { name: "unlimited_gloo", description: "Libera paredes de gelo ilimitadas.", status: "validado" },
  { name: "unlimited_ammo", description: "Libera munição infinita.", status: "validado" },
  { name: "head_shot_only", description: "Somente acertos na cabeça causam dano.", status: "validado" },
  { name: "no_airdrop", description: "Remove airdrops.", status: "validado" },
  { name: "no_vehicle", description: "Remove veículos.", status: "validado" },
  { name: "hide_kill_info", description: "Oculta informações de abate.", status: "experimental" },
  { name: "no_fall_damage", description: "Desativa dano de queda.", status: "experimental" },
  { name: "no_skill", description: "Desativa habilidades de personagem.", status: "experimental" },
  { name: "no_power_gun", description: "Desativa armas especiais.", status: "experimental" },
  { name: "acc_total_stats", description: "Acumula estatísticas da sala.", status: "experimental" },
  { name: "no_uav", description: "Desativa UAV.", status: "experimental" },
  { name: "no_bomb", description: "Desativa bomba.", status: "experimental" },
];

export const itemCatalog = [
  {
    group: "Pistolas e submetralhadoras",
    items: ["G18", "DESERT_EAGLE", "MINI_UZI", "M500", "USP2", "M1917", "P90", "UMP", "MP5", "MAC10", "VECTOR", "BIZON", "THOMPSON", "THOMPSON_X", "MP40"],
  },
  {
    group: "Rifles, precisão e escopetas",
    items: ["KINGFISHER", "M14", "SPAS12", "M1014", "G36", "SCAR", "KORD", "VSK94", "PARAFAL", "XM8", "AUG", "SKS", "MAG7", "M590", "CHARGE_BUSTER", "AK47", "GROZA", "KAR98K", "M24", "M1887", "M1887_X", "AC80", "WOODPECKER", "M249", "M249_X", "SVD", "SVD_Y", "M82B", "AWM_Y", "M4A1", "FAMAS", "AN94", "M60", "M14_I", "HEAL_SNIPER", "GROZA_X"],
  },
  {
    group: "Especiais e corpo a corpo",
    items: ["SCYTHE", "KATANA", "CG15", "M79", "GATLING", "FLAMETHROWER"],
  },
  {
    group: "Equipamento e utilitários",
    items: ["VEST_2", "VEST_3", "VEST_4", "HELMET_2", "HELMET_3", "HELMET_4", "REPAIR_KIT", "GRENADE", "FLASHBANG", "SMOKE", "GLOO_WALL", "DRAGON_FREEZE", "MUSHROOM_3"],
  },
];

export const apiErrors = [
  { status: "400", code: "insufficient_wallet_balance", action: "Recarregue a carteira. Este caso não retorna 402." },
  { status: "400", code: "config_required", action: "Envie config em POST /rooms/custom." },
  { status: "400", code: "invalid_custom_config", action: "Corrija todos os itens indicados em details[]." },
  { status: "400", code: "use_rooms_custom", action: "Envie config somente para /rooms/custom." },
  { status: "401", code: "unauthorized", action: "Confira a chave, revogação e expiração." },
  { status: "402", code: "insufficient_partner_balance", action: "Recarregue a carteira da conta parceira." },
  { status: "403", code: "partner_inactive", action: "Solicite a reativação da conta." },
  { status: "403", code: "partner_billing_not_chargeable", action: "Coparticipation não é suportado via API key." },
  { status: "404", code: "room_not_found", action: "A sessão não existe ou já foi encerrada." },
  { status: "404", code: "result_not_found", action: "A sala não foi iniciada ou o rastreamento expirou." },
  { status: "409", code: "start_not_confirmed", action: "A partida não começou; repita apenas o start." },
  { status: "409", code: "room_not_controllable", action: "O bot não controla mais o lobby." },
  { status: "429", code: "rate_limited", action: "Respeite Retry-After e verifique scope." },
  { status: "503", code: "room_host_offline", action: "Veja reconnecting; libere a sala se for false." },
  { status: "503", code: "result_unavailable", action: "Falha temporária; repita com backoff." },
  { status: "503", code: "sem código", action: "Sem capacidade; a sala não foi cobrada." },
];

export const playerV1Fields: ReferenceField[] = [
  { name: "ok", type: "boolean", description: "true quando o jogador foi encontrado." },
  { name: "player.id", type: "string", description: "UID do jogador no Free Fire." },
  { name: "player.nickname", type: "string", description: "Nick atual." },
  { name: "player.level", type: "number", description: "Nível da conta." },
  { name: "player.region", type: "string", description: "Região do servidor, como BR ou US." },
  { name: "player.blacklist", type: "boolean | null", description: "true = conta banida pela Garena; false = limpa; null = o anti-hack não respondeu nesta consulta." },
];

export const playerV2Fields: ReferenceField[] = [
  { name: "uid", type: "string", description: "UID consultado." },
  { name: "cached", type: "boolean", description: "true quando o perfil veio do cache de 5 minutos." },
  { name: "fetched_at", type: "ISO 8601", description: "Momento em que o perfil foi lido da Garena." },
  { name: "player.uid · nickname · region · level · exp · likes · bio", type: "identidade", description: "Dados públicos principais do perfil." },
  { name: "player.last_login_at · created_at", type: "string", description: "Epoch em segundos, como texto." },
  { name: "player.br_rank · br_points · cs_rank · cs_points", type: "number", description: "Rank e pontos atuais de Battle Royale e Contra Squad." },
  { name: "player.rank_details", type: "object", description: "Visibilidade do rank, ranks máximos e posições de pico." },
  { name: "player.assets", type: "object", description: "Banner, avatar, insígnia, pin, título e skins de arma exibidas." },
  { name: "player.avatar", type: "object", description: "Personagem, roupas e habilidades equipadas já resolvidas." },
  { name: "player.social", type: "object", description: "Gênero, idioma, tags e preferências de modo." },
  { name: "player.clan", type: "object | null", description: "Guilda; null quando o jogador não tem guilda." },
  { name: "player.pet", type: "object | null", description: "Pet e habilidade selecionada; null sem pet." },
  { name: "player.credit", type: "object | null", description: "Pontuação de honra e resumo do período." },
  { name: "player.activity.passes", type: "object", description: "Passes: count, owned_count, latest e history." },
  { name: "player.blacklist", type: "boolean | null", description: "Mesmo significado da v1." },
  { name: "player.blacklist_period", type: "number | null", description: "Campo period cru do anti-hack da Garena, que não documenta a unidade. null quando blacklist é null." },
];

export const playerV1Sample = `{
  "ok": true,
  "player": {
    "id": "123456789",
    "nickname": "Jogador",
    "level": 55,
    "region": "BR",
    "blacklist": false
  }
}`;

export const playerV2Sample = `{
  "ok": true,
  "uid": "123456789",
  "cached": false,
  "fetched_at": "2026-09-29T20:14:03.512Z",
  "player": {
    "uid": "123456789",
    "nickname": "Jogador",
    "region": "BR",
    "level": 55,
    "exp": 2451890,
    "likes": 1830,
    "bio": "RX",
    "br_rank": 320,
    "br_points": 3521,
    "cs_rank": 321,
    "cs_points": 88,
    "rank_details": { "max_br_rank": 321, "max_cs_rank": 322 },
    "assets": { "banner_id": 901000001, "headpic_id": 902000001 },
    "avatar": { "id": 102000008, "equipped_skills": [] },
    "clan": { "id": "3001234567", "name": "RX", "level": 5 },
    "pet": null,
    "credit_score": 100,
    "activity": {
      "passes": { "count": 2, "owned_count": 1, "latest": {}, "history": [] }
    },
    "blacklist": false,
    "blacklist_period": 0
  }
}`;

export const playerErrors = [
  { status: "400", code: "invalid_uid", action: "O UID precisa ter de 5 a 20 dígitos." },
  { status: "401", code: "missing_api_key", action: "Envie a chave em x-api-key ou Authorization: Bearer." },
  { status: "401", code: "invalid_api_key", action: "Chave com formato errado, revogada ou expirada." },
  { status: "404", code: "player_not_found", action: "A Garena não devolveu perfil para esse UID." },
  { status: "429", code: "rate_limited", action: "Cota por minuto da chave estourada; respeite Retry-After." },
  { status: "502", code: "upstream_error", action: "Falha temporária na Garena; repita com backoff." },
  { status: "503", code: "no_account_available", action: "Sem conta de consulta disponível agora; respeite Retry-After." },
  { status: "503", code: "upstream_busy", action: "Fila de consultas cheia; respeite Retry-After." },
  { status: "503", code: "key_lookup_unavailable", action: "Validação da chave indisponível; repita em 5 segundos." },
];
